const toLines = (value) => {
  if (Array.isArray(value)) {
    return value.map((line) => line == null ? '' : String(line));
  }

  if (value == null || value === '') return [];
  return String(value).replace(/\r\n?/g, '\n').split('\n');
};

const stripBulletMarker = (line) =>
  line.replace(/^\s*[•●▪◦*-]\s+/, '');

/**
 * Removes only recognizable instruction-list prefixes. Requiring whitespace
 * after numeric punctuation keeps quantities such as "1.5 cups" intact.
 */
export const stripInstructionListMarker = (line) => {
  const value = line == null ? '' : String(line);
  return value
    .replace(/^\s*\d+[.)](?:\s+|$)/, '')
    .replace(/^\s*step\s+\d+\s*[:.)-](?:\s*|$)/i, '');
};

export const isInstructionHeading = (line) => {
  const trimmed = line == null ? '' : String(line).trim();
  return trimmed.endsWith(':') &&
    !/^\s*step\s+\d+\s*:\s*$/i.test(trimmed);
};

export const hasSingleInstructionStep = (instructions) =>
  toLines(instructions).filter(line =>
    stripInstructionListMarker(line).trim() && !isInstructionHeading(line)
  ).length === 1;

export const withoutSingleStepNumber = (instructions) =>
  hasSingleInstructionStep(instructions)
    ? toLines(instructions).map(stripInstructionListMarker).join('\n')
    : instructions;

export const formatImportedIngredients = (ingredients) => {
  return toLines(ingredients)
    .map((line) => {
      const trimmed = stripBulletMarker(line).trim();
      if (!trimmed || trimmed.endsWith(':')) return trimmed;
      return `• ${trimmed}`;
    })
    .join('\n');
};

export const formatImportedInstructions = (instructions) => {
  let stepNumber = 0;
  const singleStep = hasSingleInstructionStep(instructions);

  return toLines(instructions)
    .map((line) => {
      let trimmed = stripBulletMarker(line).trim();
      if (!trimmed) return '';

      const isHeading = isInstructionHeading(trimmed);
      trimmed = stripInstructionListMarker(trimmed).trim();

      if (!trimmed || isHeading) return trimmed;
      if (singleStep) return trimmed;
      stepNumber += 1;
      return `${stepNumber}. ${trimmed}`;
    })
    .join('\n');
};